import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import QuillEditor from '../../Shared/QuillEditor.vue';
import ReviewsChart from '../Charts/ReviewsChart.vue';
import BarChart from '../Charts/BarChart.vue';

export default {
    name: 'Institutions',
    mixins: [HelperMixin],
    components: {
        PaginationHelper,
        QuillEditor,
        ReviewsChart,
        BarChart,
    },

    async created() {
        await this.CheckLoginStatus();
        await this.GetAllTypes();

        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY');
        },

        momentTime: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            FilterBy: 1,
            Search: '',
            
            IsFree: '',
            IsDiscount: '',
            SalesStatus: '',
            ViewStatus: '',

            ScreenTitle: '  المؤسسات الصحية   ',
            ScreenTitleSingle: '   مؤسسة   ',
            ScreenTitleSingleAl: ' المؤسسة ',

            Info: [],
            Statistics: [],
            

            AddDialog: false,

            SelectedItem: '',

            ruleForm: {
                Id: '',
                TypesId: '',
                InstitutionsTypesId: '',
                Name: '',
                Phone: '',
                Email: '',
                AuthorizedName: '',
                AuthorizedPhone: '',
                Descriptions: '',
                ImageName: '',
                Image: '',
            },
            rules: {
                TypesId: this.$helper.Required(),
                InstitutionsTypesId: this.$helper.Required(),
                Name: this.$helper.Required(),
                Phone: this.$helper.Required(),
                Email: this.$helper.Required(),
                AuthorizedName: this.$helper.Required(),
                AuthorizedPhone: this.$helper.Required(),
            },





            //View Info
            ChartInfo: [],



            //InstitutionsOrders
            InstitutionsOrdersSearch: '',
            InstitutionsOrdersInfo: [],
            InstitutionsOrdersStatistics: [],
            InstitutionsOrdersSelectedItem: '',
            InstitutionsOrdersScreenTitle: ' الخدمات  ',
            InstitutionsOrdersScreenTitleSingle: ' خدمة',
            InstitutionsOrdersScreenTitleSingleAl: 'الخدمة',
            InstitutionsOrdersruleForm: {
                Id: '',
                InstitutionsId: '',
                TypesId: '',
                InstitutionsTypesId: '',
                InstitutionsServiceValueId: '',
            },
            InstitutionsOrdersrules: {
                InstitutionsId: this.$helper.Required(),
                TypesId: this.$helper.Required(),
                InstitutionsTypesId: this.$helper.Required(),
                InstitutionsServiceValueId: this.$helper.Required(),
            },




            //InstitutionsPayments
            InstitutionsPaymentsSearch: '',
            InstitutionsPaymentsInfo: [],
            InstitutionsPaymentsStatistics: [],
            InstitutionsPaymentsSelectedItem: '',
            InstitutionsPaymentsScreenTitle: ' الدفعات المالية   ',
            InstitutionsPaymentsScreenTitleSingle: ' دفعة ',
            InstitutionsPaymentsScreenTitleSingleAl: 'الدفعة ',
            InstitutionsPaymentsruleForm: {
                Id: '',
                InstitutionsOrdersId: '',
                Value: '',
            },
            InstitutionsPaymentsrules: {
                InstitutionsOrdersId: this.$helper.Required(),
                Value: this.$helper.Required(),
            },



        };
    },



    methods: {

        GetInstitutionsTypes() {
            this.GetAllInstitutionsTypes(this.ruleForm.TypesId);
        },


        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetInstitutions(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);
                    this.$blockUI.Start();
                    this.$http.AddInstitutions(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.Back();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإظافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإظافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.TypesId = item.typesId;
            this.GetAllInstitutionsTypes(item.typesId);
            this.ruleForm.InstitutionsTypesId = item.institutionsTypesId;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;
            this.ruleForm.authorizedName = item.authorizedName;
            this.ruleForm.authorizedPhone = item.authorizedPhone;
            this.ruleForm.Descriptions = item.descriptions;
            this.state = 2;

        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(this.ruleForm.Id);
                    this.$blockUI.Start();
                    this.$http.EditInstitutions(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.Back();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteInstitutions(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        //Upload File
        SelectImage(file) {

            // Check if file is defined
            if (!file) {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type; // Access type property safely
            str = str.substring(0, 5);

            // Check if the file type is an image
            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        },



        //Info
        ChangeTab(tabname) {
            if (tabname == 'InstitutionsOrders') {
                this.GetInstitutionsOrdersInfo();
            } else if (tabname == 'InstitutionsPayments') {
                this.GetInstitutionsPaymentsInfo();
            }
        },

        OpentInfoDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.TypesId = item.typesId;
            
            this.GetAllInstitutionsServiceValue(item.institutionsTypesId);
            this.ruleForm.InstitutionsTypesId = item.institutionsTypesId;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;
            this.ruleForm.authorizedName = item.authorizedName;
            this.ruleForm.authorizedPhone = item.authorizedPhone;
            this.ruleForm.Descriptions = item.descriptions;
            this.state = 3;
            this.ChangeTab('InstitutionsOrders');
            //this.GetChartInfo();
        },









        //InstitutionsOrders
        GetInstitutionsOrdersInfo() {
            this.InstitutionsOrdersInfo = [];
            this.InstitutionsOrdersStatistics = [];

            if (!this.InstitutionsOrdersSearch)
                this.$blockUI.Start();

            this.$http.GetInstitutionsOrders(this.SelectedItem.id, this.InstitutionsOrdersSearch)
                .then(response => {
                    if (!this.InstitutionsOrdersSearch)
                        this.$blockUI.Stop();

                    this.InstitutionsOrdersInfo = response.data.info;
                    this.InstitutionsOrdersStatistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.InstitutionsOrdersSearch)
                        this.$blockUI.Stop();
                });
        },

        InstitutionsOrderssubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.InstitutionsOrdersruleForm.Id = Number(0);
                    this.InstitutionsOrdersruleForm.InstitutionsId = this.SelectedItem.id;
                    this.$blockUI.Start();
                    this.$http.AddInstitutionsOrders(this.InstitutionsOrdersruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInstitutionsOrdersInfo();
                            this.ClearForm(this.InstitutionsOrdersruleForm);
                            this.$helper.DestroyElemntById('InstitutionsOrdersClose');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإظافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإظافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        InstitutionsOrdersOpentEditDialog(item) {
            this.InstitutionsOrdersSelectedItem = item;
            this.InstitutionsOrdersruleForm.Id = item.id;
            this.InstitutionsOrdersruleForm.Name = item.name;
            this.InstitutionsOrdersruleForm.Number = item.number;
            this.InstitutionsOrdersruleForm.CourseId = item.courseId;
            this.InstitutionsOrdersruleForm.Descriptions = item.descriptions;

        },

        InstitutionsOrderssubmitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.InstitutionsOrdersruleForm.Id = Number(this.InstitutionsOrdersruleForm.Id);
                    this.InstitutionsOrdersruleForm.Value = Number(this.InstitutionsOrdersruleForm.Value);
                    this.InstitutionsOrdersruleForm.InstitutionsId = this.SelectedItem.id;
                    this.$blockUI.Start();
                    this.$http.EditInstitutionsOrderss(this.InstitutionsOrdersruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInstitutionsOrdersInfo();
                            this.ClearForm(this.InstitutionsOrdersruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        InstitutionsOrdersDelete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteInstitutionsOrders(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInstitutionsOrdersInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },



        //InstitutionsPayments
        GetInstitutionsPaymentsInfo() {

            this.GetRemindValue(this.SelectedItem.id);

            this.InstitutionsPaymentsInfo = [];
            this.InstitutionsPaymentsStatistics = [];

            if (!this.InstitutionsPaymentsSearch)
                this.$blockUI.Start();

            this.$http.GetInstitutionsPayments(this.SelectedItem.id, this.InstitutionsPaymentsSearch)
                .then(response => {
                    if (!this.InstitutionsPaymentsSearch)
                        this.$blockUI.Stop();

                    this.InstitutionsPaymentsInfo = response.data.info;
                    this.InstitutionsPaymentsStatistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.InstitutionsPaymentsSearch)
                        this.$blockUI.Stop();
                });
        },

        InstitutionsPaymentssubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.InstitutionsPaymentsruleForm.Id = Number(0);
                    this.InstitutionsPaymentsruleForm.Value = Number(this.InstitutionsPaymentsruleForm.Value);
                    this.$blockUI.Start();
                    this.$http.AddInstitutionsPayments(this.InstitutionsPaymentsruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInstitutionsPaymentsInfo();
                            this.ClearForm(this.InstitutionsPaymentsruleForm);
                            this.$helper.DestroyElemntById('InstitutionsPaymentsClose');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإظافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإظافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        InstitutionsPaymentsDelete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteInstitutionsPayments(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInstitutionsPaymentsInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },









        //Support Info

        Back() {
            this.state = 0;
            this.ClearForm(this.ruleForm);
            this.SelectedItem = '';
            this.GetInfo(this.pageNo);
        },

        ChangeFilter(id) {
            this.FilterBy = id;
            this.IsFree = '';
            this.IsDiscount = '';
            this.SalesStatus = '';
            this.ViewStatus = '';
        },

        Refresh() {
            this.state = 0;
            this.ClearForm(this.ruleForm);
            this.SelectedItem = '';
            this.FilterBy = 1;
            this.Search = '';
            this.IsFree = '';
            this.IsDiscount = '';
            this.SalesStatus = '';
            this.ViewStatus = '';
            this.GetInfo(this.pageNo);
        }

    }
}
